var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-board--hud"},[_c('span',[_vm._v(_vm._s(_vm.currentQuestion)+"/"+_vm._s(_vm.totalQuestions))]),_c('span',[_vm._v(_vm._s(_vm.retries)+" ❤")])])}
var staticRenderFns = []

export { render, staticRenderFns }